import { baseApi } from 'core/api';
import { useToastStore } from 'store/modules';

const state = () => ({
    _summary: null,
    _sampleMessage: null,
});

const getters = {
    tollFreeVerificationSummaryMessage: (state) => state._summary,
    tollFreeVerificationSampleMessage: (state) => state._sampleMessage,
};

const actions = {
    getTollFreeSummaryMessage({ companyName, industry = '', website = '' }) {
        return baseApi
            .get('ai/api/toll-free-verification/description', {
                params: {
                    company_name: companyName,
                    industry: industry,
                    website: website,
                },
            })
            .then((response) => {
                this._setTollFreeVerificationStateUpdate({
                    summary: response.data?.result_message,
                });

                return response.data;
            })
            .catch((error) => {
                useToastStore().showToast({
                    type: 'danger',
                    message: error.response.data.message,
                });

                return error;
            });
    },

    getTollFreeSampleMessage({
        companyName,
        useCase,
        description = '',
        industry = '',
        website = '',
    }) {
        return baseApi
            .get('ai/api/toll-free-verification/sample-message', {
                params: {
                    company_name: companyName,
                    use_case: useCase,
                    description: description,
                    industry: industry,
                    website: website,
                },
            })
            .then((response) => {
                this._setTollFreeVerificationStateUpdate({
                    sampleMessage: response.data?.result_message,
                });

                return response.data;
            })
            .catch((error) => {
                useToastStore().showToast({
                    type: 'danger',
                    message: error.response.data.message,
                });

                return error;
            });
    },

    // Private methods
    _setTollFreeVerificationStateUpdate(data) {
        for (let key in data) {
            const mappedKey = key.startsWith('_') ? key : `_${key}`;
            this[mappedKey] = data[key];
        }
    },
};

export default {
    state,
    getters,
    actions,
};
